module.exports = __webpack_public_path__ + "img/IsPickupComments.124c6719.svg";